import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { PositionManagementInfo } from '../../model/PositionManagementInfo.model';

@Component({
  selector: 'app-positionlevel-project',
  templateUrl: './positionlevel-project.component.html',
  styleUrls: ['./positionlevel-project.component.css']
})
export class PositionlevelProjectComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _PositionModule: number;

  ListAccessLevel: LookupInfo[] = [];
  ListStatus: LookupInfo[] = [];
  ListPositionManagement: PositionManagementInfo[] = [];

  //Search
  isSearchSubmitted: boolean= false;
  txtSchPositionName: string;
  ddlSchPositionLevel: string;
  ddlSchPositionStatus: string;

  //Form variable
  positionForm: FormGroup;
  positionInfo: PositionManagementInfo = new PositionManagementInfo;
  IsDuplicateCode: boolean;

  //Pagination
  currentPageNumber: number = 1;
  totalPositions: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this._PositionModule = ConstVariable.PositionProjectModule; //Project Delivery
    this.ddlSchPositionStatus = ''

    //Load init data
    this.LoadLookupType("MASTERSTATUS").then((data) => {
      this.ListStatus = data;
    });
    this.LoadLookupType("POSITIONLEVEL").then((data) => {
        this.ListAccessLevel = data;
      });
    this.LoadPositionList().then((data) => {
      this.ListPositionManagement = data;
    });
    this.LoadCountPositionList();

    //Declare form
    this.positionForm = new FormGroup({
      PositionCode: new FormControl(this.positionInfo.PositionCode, [Validators.required]),
      PositionName: new FormControl(this.positionInfo.PositionName, [Validators.required]),
      PositionLevel: new FormControl(this.positionInfo.PositionLevel),
      PositionStatus: new FormControl(this.positionInfo.FlagActive),
      FlagCreate: new FormControl(this.positionInfo.FlagCreate),
      FlagEdit: new FormControl(this.positionInfo.FlagEdit),
      FlagDeleteRights: new FormControl(this.positionInfo.FlagDeleteRights),
      FlagApprove: new FormControl(this.positionInfo.FlagApprove),
      FlagAssign: new FormControl(this.positionInfo.FlagAssign),
      FlagView: new FormControl(this.positionInfo.FlagView),
    });
  }

  get PositionCode() { return this.positionForm.get('PositionCode'); }
  get PositionName() { return this.positionForm.get('PositionName'); }
  get PositionLevel() { return this.positionForm.get('PositionLevel'); }


  async LoadLookupType(LookupType): Promise<LookupInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadPositionList(positionId: number = 0): Promise<PositionManagementInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['ModuleId'] = this._PositionModule;
      objectjson['PositionId'] = positionId;

      objectjson['PositionName'] = this.txtSchPositionName;
      objectjson['PositionLevel'] = $('#ddlSchPositionLevel').val();
      objectjson['FlagActive'] = $('#ddlSchPositionStatus').val();

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<PositionManagementInfo[]>(this.baseurl + "Actions/GetActionList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountPositionList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ModuleId'] = this._PositionModule;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "Actions/GetCountActionsList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.isSearchSubmitted = true;
    this.LoadPositionList().then((data) => {
      this.ListPositionManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchPositionName = null;
    $('#ddlSchPositionLevel').val('')
    $('#ddlSchPositionStatus').val('')

    this.currentPageNumber = 1;
    this.isSearchSubmitted = false;
    this.LoadPositionList().then((data) => {
      this.ListPositionManagement = data;
    });
  }

  //Create btn
  OnCreatePosition_Click() {

    $('#modalCreatePositionTitle').html('Create Position');
    $('#modalCreateOrEditPosition').modal();
    this.positionInfo = new PositionManagementInfo;
    this.PositionCode.setValue(null);
    this.PositionName.setValue(null);
    //this.setValue(null);
    this.positionForm.get('FlagCreate').setValue(false)
    this.positionForm.get('FlagEdit').setValue(false)
    this.positionForm.get('FlagDeleteRights').setValue(false)
    this.positionForm.get('FlagApprove').setValue(false)
    this.positionForm.get('FlagAssign').setValue(false)
    this.positionForm.get('FlagView').setValue(false)

    this.positionForm.markAsUntouched();
    this.positionForm.markAsPristine();

  }
  async OnSubmitCreatePosition_Click() {
    if (this.positionForm.valid) {
      //this.Loading(true, 'Creating...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.positionForm.value;
        //ปรับ flag ก่อนนำไป save ลง DB
        objectjson['FlagCreate'] = !!this.positionForm.value['FlagCreate'] ? 'Y' : 'N';
        objectjson['FlagEdit'] = !!this.positionForm.value['FlagEdit'] ? 'Y' : 'N';
        objectjson['FlagDeleteRights'] = !!this.positionForm.value['FlagDeleteRights'] ? 'Y' : 'N';
        objectjson['FlagApprove'] = !!this.positionForm.value['FlagApprove'] ? 'Y' : 'N';
        objectjson['FlagAssign'] = !!this.positionForm.value['FlagAssign'] ? 'Y' : 'N';
        objectjson['FlagView'] = !!this.positionForm.value['FlagView'] ? 'Y' : 'N';
        objectjson['ModuleId'] = this._PositionModule;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Actions/InsertActionsManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = 'Done.';
            this.detailmodal = 'Position was updated successfully.';
            $('#ModalComplate').modal();
            $('#modalCreateOrEditPosition').modal('hide');
            //setTimeout(() => { //this.Loading(false, '');
            //}, 500);

            //Reload
            this.LoadPositionList().then((data) => {
              this.ListPositionManagement = data;
            });;
          });
      }
    } else {
      this.markFormGroupTouched(this.positionForm);
    }

  }
  async OnEdit_Click(positionId) {


    if (!!positionId) {
      //this.Loading(true, 'Loading...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadPositionList(positionId).then((data) => {

          this.positionInfo = data[0];
          this.PositionCode.setValue(data[0].PositionCode);
          this.PositionName.setValue(data[0].PositionName);
          //this.PositionLevel.setValue(data[0].PositionLevel);
          this.positionForm.get('PositionLevel').setValue(data[0].PositionLevel.toString())
          this.positionForm.get('FlagCreate').setValue(data[0].FlagCreate == 'Y' ? true : false)
          this.positionForm.get('FlagEdit').setValue(data[0].FlagEdit == 'Y' ? true : false)
          this.positionForm.get('FlagDeleteRights').setValue(data[0].FlagDeleteRights == 'Y' ? true : false)
          this.positionForm.get('FlagApprove').setValue(data[0].FlagApprove == 'Y' ? true : false)
          this.positionForm.get('FlagAssign').setValue(data[0].FlagAssign == 'Y' ? true : false)
          this.positionForm.get('FlagView').setValue(data[0].FlagView == 'Y' ? true : false)

          setTimeout(() => {
            //this.Loading(false, '');
            $('#modalCreatePositionTitle').html('Edit Sale Team');
            $('#modalCreateOrEditPosition').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.positionForm.valid) {
      //this.Loading(true, 'Save changes...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.positionForm.value;
        objectjson['ModuleId'] = this._PositionModule;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['PositionId'] = this.positionInfo.PositionId;

        objectjson['FlagCreate'] = !!this.positionForm.value['FlagCreate'] ? 'Y' : 'N';
        objectjson['FlagEdit'] = !!this.positionForm.value['FlagEdit'] ? 'Y' : 'N';
        objectjson['FlagDeleteRights'] = !!this.positionForm.value['FlagDeleteRights'] ? 'Y' : 'N';
        objectjson['FlagApprove'] = !!this.positionForm.value['FlagApprove'] ? 'Y' : 'N';
        objectjson['FlagAssign'] = !!this.positionForm.value['FlagAssign'] ? 'Y' : 'N';
        objectjson['FlagView'] = !!this.positionForm.value['FlagView'] ? 'Y' : 'N';

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Actions/UpdateActionsManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = 'Done.';
              this.detailmodal = 'Position was updated successfully.';
              $('#ModalComplate').modal();
              $('#modalCreateOrEditPosition').modal('hide');
              //setTimeout(() => { //this.Loading(false, ''); }, 500);

              //Reload
              this.LoadPositionList().then((data) => {
                this.ListPositionManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditPosition').modal('hide');
              //setTimeout(() => { //this.Loading(false, ''); }, 500);

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.positionForm);
    }
  }
  async OnDelete_Click(positionId) {
    if (!!positionId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //this.Loading(true, 'Deleting...');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.positionForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['PositionId'] = positionId;

        let arrjson: PositionManagementInfo[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Actions/DeleteActionsManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {

              this.titlemodal = 'Done.';
              this.detailmodal = 'Deleted successfully.';
              $('#ModalComplate').modal();

              //setTimeout(() => { //this.Loading(false, ''); }, 500);

              //Reload
              this.LoadPositionList().then((data) => {
                this.ListPositionManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

              //setTimeout(() => { //this.Loading(false, ''); }, 500);

            }

            this.isSearchSubmitted = false;
          });
      }
    }
  }
  async OnDeleteList_Click() {
    if (confirm("Are you sure to delete these position?")) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var listDeleteChecked = $('[name="checkboxdelete"]:checked');
        let arrjson: PositionManagementInfo[] = [];

        //เก็บ List id ที่จะ delete
        $.each(listDeleteChecked, function (idx, val) {

          var curId = $(val).data('positionid');
          var model = new PositionManagementInfo;
          model.PositionId = curId;
          arrjson.push(model);
        });

        //ส่งไป Delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "Actions/DeleteActionsManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {

              this.titlemodal = 'Done.';
              this.detailmodal = 'Deleted successfully.';
              $('#ModalComplate').modal();

              //setTimeout(() => { //this.Loading(false, ''); }, 500);

              //Reload
              this.LoadPositionList().then((data) => {
                this.ListPositionManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

              //setTimeout(() => { //this.Loading(false, ''); }, 500);
            }

            this.isSearchSubmitted = false;
          });
      }
    }
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {
      //this.Loading(true, 'Loading...');

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadPositionList(positionId).then((data) => {

          this.positionInfo = data[0];
          this.PositionCode.setValue(data[0].PositionCode);
          this.PositionName.setValue(data[0].PositionName);
          //this.PositionLevel.setValue(data[0].PositionLevel);
          this.positionForm.get('PositionLevel').setValue(data[0].PositionLevel.toString())
          this.positionForm.get('FlagCreate').setValue(data[0].FlagCreate == 'Y' ? true : false)
          this.positionForm.get('FlagEdit').setValue(data[0].FlagEdit == 'Y' ? true : false)
          this.positionForm.get('FlagDeleteRights').setValue(data[0].FlagDeleteRights == 'Y' ? true : false)
          this.positionForm.get('FlagApprove').setValue(data[0].FlagApprove == 'Y' ? true : false)
          this.positionForm.get('FlagAssign').setValue(data[0].FlagAssign == 'Y' ? true : false)
          this.positionForm.get('FlagView').setValue(data[0].FlagView == 'Y' ? true : false)

          setTimeout(() => {
            //this.Loading(false, '');
            $('#modalCreatePositionTitle').html('Edit Sale Team');
            $('#modalCreateOrEditPosition').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ModuleId'] = this._PositionModule;
      objectjson['PositionCode'] = this.PositionCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "Actions/CheckDuplicatePositionCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadPositionList().then((data) => {
      this.ListPositionManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalPositions = data;
    if (this.totalPositions == 0) this.currentPageNumber = 0;

    this.totalPages = Math.ceil(this.totalPositions / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
